module.exports = __webpack_public_path__ + "static/media/wellnessIcon.152b67c9.png";